import { Component, inject, OnInit, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from './shared/services/auth.service';
import { NgxSpinnerComponent } from 'ngx-spinner';
import { ILoggedInUser } from './shared/models/user';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NgxSpinnerComponent],
  template: `
  <ngx-spinner name='loading-spinner' type='ball-scale-multiple'>Loading....</ngx-spinner>
  <router-outlet></router-outlet>
  `,
})
export class App implements OnInit {
  protected readonly title = signal('ClientApp');

  private authSvc = inject(AuthService)


  ngOnInit() {
    let loggedInUser: ILoggedInUser | null = null;
    if (localStorage.getItem('loggedInUser'))
      loggedInUser = JSON.parse(localStorage.getItem('loggedInUser') ?? '');
    if (loggedInUser)
      this.authSvc.setLoggedInUser(loggedInUser)
  }
}
